import { Insurance } from "../../../services/scheduleService/model/schedule/Insurance";
import { CompositeSpecification } from "../../../utils/Specification";

export class RequiresHealthTexasAuth extends CompositeSpecification<Insurance> {
    IsSatisfiedBy(candidate: Insurance): boolean {
        const healthTexasGroups = ['92124', '91637', '92142', '90770'];
        const groupNumber = candidate.groupNumber ?? '';
        return healthTexasGroups.some(code => groupNumber.includes(code));
    }
}
